import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {StoreModule} from '@ngrx/store';
import * as fromDetailCategory from './+state/detail-category.reducer';
import {EffectsModule} from '@ngrx/effects';
import {DetailCategoryEffects} from './+state/detail-category.effects';
import {NGXLogger} from 'ngx-logger';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature(
      fromDetailCategory.CATEGORY_FEATURE_KEY,
      fromDetailCategory.reducer
    ),
    EffectsModule.forFeature([DetailCategoryEffects]),
  ]
})
export class DetailCategoryStoreModule {

  constructor(private logger: NGXLogger) {
    logger.trace('*---------------------------------------------------------------------*');
    logger.trace('*', this.constructor.name, 'Loaded');
    logger.trace('*---------------------------------------------------------------------*');
  }

}
